import React from 'react';
import { Globe } from 'lucide-react';
import { getLamnsoDate } from '@/lib/lamnsoDate';

export default function LamnsoDateDisplay() {
  const ld = getLamnsoDate();

  return (
    <div className="inline-flex flex-col gap-0.5 px-4 py-2.5 rounded-xl bg-[#FDF6F0] border border-[#D4A373]/30" data-testid="lamnso-date">
      <div className="flex items-center gap-2">
        <Globe className="w-4 h-4 text-[#D4A373] flex-shrink-0" />
        <span className="text-sm font-semibold text-[#1C1917]" style={{ fontFamily: "'Outfit', sans-serif" }}>
          {ld.formatted}
        </span>
      </div>
      <span className="text-[10px] text-[#A8A29E] pl-6">{ld.gregorian}</span>
    </div>
  );
}
